import { render, staticRenderFns } from "./MutasiSummary.vue?vue&type=template&id=4f3aaaf2&scoped=true"
import script from "./MutasiSummary.vue?vue&type=script&lang=js"
export * from "./MutasiSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3aaaf2",
  null
  
)

export default component.exports